import EditableDetailsCardWrapper from "entity-app/shared-components/editable-details-card-wrapper/editable-details-card-wrapper";
import FeatureActivityCard from "components/feature-activity-card/feature-activity-card";
import FeatureAttachments from "components/feature-attachments";
import { useContext, useMemo } from "react";
import {
  isPermissionNotGrantted,
  ProjectContext,
  TProjectContext
} from "context/ProjectProvider";
import { ProjectPermissionEnum } from "constants/index";
import { TFetureDetailUpdateAction } from "entity-app/models";
import { ErrorBoundary } from "@sentry/react";
import CustomFields from "components/custom-fields";
import { FeatureTypes } from "entity-app/constants";
import DesignLinkedTopSection from "./components/design-linked-top-section";
import DesignPackageGeneralInfo from "./components/design-package-general-info";

function DesignPackageDetailsTab(props: {
  featureInstanceData: any;
  actions: TFetureDetailUpdateAction;
  featureId: string;
}) {
  const { featureInstanceData, actions, featureId } = props;
  const {
    tokenContents,
    columnHeaders: { designPackageCustomColumns },
    isFeatureFlagEnabled,
    isProjectArchived
  }: TProjectContext = useContext(ProjectContext);

  const isAttachementFeatureEnabled =
    !isFeatureFlagEnabled("DISABLE_ATTACHMENT");
  const permissionsForActivityCard = useMemo(() => {
    return isProjectArchived ? [] : ["create_comment"];
  }, [isProjectArchived]);
  const cannotWriteAccessOfDesignPackage = isPermissionNotGrantted(
    ProjectPermissionEnum.DesignPackageWrite,
    tokenContents?.role ?? ""
  );

  return (
    <div className="flex flex-col p-4 space-y-4">
      <DesignLinkedTopSection
        actions={actions}
        featureInstanceData={featureInstanceData}
        disabled={cannotWriteAccessOfDesignPackage}
      />
      <div className="grid grid-cols-3 gap-4 w-full">
        <EditableDetailsCardWrapper title="General Information">
          <DesignPackageGeneralInfo
            featureInstanceData={featureInstanceData}
            actions={actions}
            disabled={cannotWriteAccessOfDesignPackage}
          />
        </EditableDetailsCardWrapper>

        <FeatureActivityCard
          historyTabContents={<div>History</div>}
          featureId={featureId}
          featureKey="feature_instance_id"
          permissions={permissionsForActivityCard}
          isAttachementFeatureEnabled={isAttachementFeatureEnabled}
          showHistoryTab={false}
          auditFeatureType="DESIGN_PACKAGE"
        />

        {isAttachementFeatureEnabled && (
          <EditableDetailsCardWrapper title="Attachments">
            <FeatureAttachments
              featureId={featureId}
              featureInstanceData={featureInstanceData}
              auditFeatureType="DESIGN_PACKAGE"
            />
          </EditableDetailsCardWrapper>
        )}
      </div>
      {designPackageCustomColumns?.length > 0 && (
        <div className="grid grid-cols-3 gap-4 w-full">
          <EditableDetailsCardWrapper
            title="Others"
            data-testid="material-detail-cards-others-wrapper"
          >
            <ErrorBoundary>
              <CustomFields
                featureInstanceData={featureInstanceData}
                data-testid="material-detail-cards-others"
                type={FeatureTypes.DESIGN_PACKAGE}
                columns={designPackageCustomColumns}
                disabled={!!isProjectArchived}
              />
            </ErrorBoundary>
          </EditableDetailsCardWrapper>
        </div>
      )}
    </div>
  );
}

export default DesignPackageDetailsTab;
